import request from "../../shared/request";

export const fetchAllSaleLink = () => {
  return request("v1/services/affiliates/sales");
};

export const fetchSalesDetails = () => {
  return request("v1/services/affiliates/sales/details");
};
